import React, { useEffect, useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { getUserState } from "../../app/selector";
import { BACKEND_URL } from "constants";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { resetPassword } = useSelector(getUserState);

  const [email, setEmail] = useState("");
  const [responseMessage, setResponseMessage] = useState({
    msg: "",
    variant: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cooldown, setCooldown] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setResponseMessage({
        msg: "Please enter your email.",
        variant: "warning",
      });
      return;
    }

    setIsSubmitting(true);
    setCooldown(true);

    try {
      await axios.post(`${BACKEND_URL}/forget-password`, { email });

      setResponseMessage({
        msg: `A reset link has been sent to ${email}.`,
        variant: "success",
      });
    } catch (error) {
      console.error(error);

      let message =
        error?.response?.data?.error || `${email} is not registered.`;

      if (error?.response?.status === 429) {
        message =
          "Too many reset requests. Please wait a moment before trying again.";
      } else if (
        !error.response &&
        (error.message?.toLowerCase().includes("cors") ||
          error.message?.toLowerCase().includes("network"))
      ) {
        message =
          "Request blocked or network issue detected. Please wait before trying again.";
      }

      setResponseMessage({
        msg: message,
        variant: "danger",
      });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setCooldown(false), 3000);
    }
  };

  useEffect(() => {
    if (resetPassword) {
      navigate("/reset-password");
    }
  }, [resetPassword, navigate]);

  return (
    <div className="forgot-password-page">
      <div className="forget-password bg-light rounded">
        <div className="forget-password-header">
          <h2 className="forget-password-title">Forgot Password</h2>
          <p className="forget-password-subtitle">
            Enter your registered email to receive a password reset link.
          </p>
        </div>

        <Form onSubmit={handleSubmit} className="forget-password-form">
          <Form.Group controlId="formForgetPassword" className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={email}
              placeholder="Enter your email"
              onChange={handleInputChange}
              required
            />
          </Form.Group>

          <Button
            variant="success"
            type="submit"
            disabled={isSubmitting || cooldown}
            className="forget-password-button"
          >
            {isSubmitting ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Sending...
              </>
            ) : (
              "Send Reset Link"
            )}
          </Button>
        </Form>

        {responseMessage.msg && (
          <Alert className="forget-password-alert" variant={responseMessage.variant}>
            {responseMessage.msg}
          </Alert>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;